/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientAllergies = sqliteTable('patient_allergies', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  allergy_type: text('allergy_type'),
  substance: text('substance'),
  reaction: text('reaction'),
  severity: text('severity'),
  deleted_at: text('deleted_at'),
});
